export default __webpack_public_path__ + "static/media/CRDoubleToroOpen.8903a25d.jpg";